import React, {PureComponent} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {Input} from "@irati/ui/src/Typography"
import {Checkbox} from "@irati/ui/src/FormItem"

import {Container, Label} from "./styled"

interface Props extends InjectIntl {
  id: string
  checked: boolean
  value: string
  name: string
  onClick: () => void
}

class CheckboxOption extends PureComponent<Props> {
  render() {
    const {id, value, name, checked, onClick} = this.props

    return (
      <Label htmlFor={value}>
        <Container id={id} alignItems="center">
          <Checkbox flush name={value} checked={checked} onChange={onClick}>
            <Input bold>{name}</Input>
          </Checkbox>
        </Container>
      </Label>
    )
  }
}

export default injectIntl(CheckboxOption)
